/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Changes_HeaderInputs */

const en_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const fr_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications`)
};

const de_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen`)
};

const it_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiamenti`)
};

const ru_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения`)
};

const es_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const zh_cn2_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`变化`)
};

const ja_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更点`)
};

const hi_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन`)
};

const pt_pt2_compare_event_groups_csv_changes_header = /** @type {(inputs: Compare_Event_Groups_Csv_Changes_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudanças`)
};

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Compare_Event_Groups_Csv_Changes_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_changes_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Changes_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Changes_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_changes_header(inputs)
	if (locale === "de") return de_compare_event_groups_csv_changes_header(inputs)
	if (locale === "it") return it_compare_event_groups_csv_changes_header(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_changes_header(inputs)
	if (locale === "es") return es_compare_event_groups_csv_changes_header(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_changes_header(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_changes_header(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_changes_header(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_changes_header(inputs)
	return en_compare_event_groups_csv_changes_header(inputs)
});